








import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { BaseAccordion, BaseAccordionItem } from '@shared/ui';
export interface IAccordionItem {
  header: string;
  text: string;
}
export default defineComponent({
  name: 'StoryblokAccordion',
  components: { BaseAccordion, BaseAccordionItem },
  props: {
    items: {
      type: Array as PropType<IAccordionItem[]>,
      required: true,
    },
  },
});
